import {ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AbstractControl} from "@angular/forms";
import {Field} from "@app/interfaces";
import {FormHelperService} from "@app/util/form-helper.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-form-input-vehicle-model',
    templateUrl: './form-input-vehicle-model.component.html',
    styleUrls: ['./form-input-vehicle-model.component.scss'],
    standalone: false
})
export class FormInputVehicleModelComponent implements OnChanges {

  @Input() control: AbstractControl;

  @Input() field: Field<string>;

  public initialModelUuid;

  public disabled = false;

  private subscription: Subscription;

  private lastAutoTitle: string | null = null;

  constructor(private ref: ChangeDetectorRef, private formHelperService: FormHelperService) {

  }

  onVehicleSelect($event: any) {
    if ($event) {
      this.control.setValue($event.vehicleModelUuid);
      this.autoFillVehicleTitle($event);
    } else {
      this.control.setValue(null);
      this.clearVehicleTitleIfAuto();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.control.currentValue) {
      this.initialModelUuid = changes.control.currentValue.value;
      this.ref.markForCheck();

      if (this.control.parent) {
        const vehicleTitleControl = this.formHelperService.findControl('vehicle_title', this.control);
        if (vehicleTitleControl) {
          this.lastAutoTitle = vehicleTitleControl.value || null;
        }
      }

      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      this.subscription = changes.control.currentValue.statusChanges.subscribe((status: string) => {
        this.disabled = status.toLowerCase() === 'disabled';
        this.ref.markForCheck();
      });
    }
  }

  private autoFillVehicleTitle($event: any): void {
    const vehicleTitleControl = this.formHelperService.findControl('vehicle_title', this.control);
    if (!vehicleTitleControl) {
      return;
    }

    const newTitle = `${$event.vehicleBrand.name} ${$event.name}`;
    const currentTitle = vehicleTitleControl.value;

    if (!currentTitle || currentTitle === this.lastAutoTitle) {
      vehicleTitleControl.setValue(newTitle);
      this.lastAutoTitle = newTitle;
    }
  }

  private clearVehicleTitleIfAuto(): void {
    const vehicleTitleControl = this.formHelperService.findControl('vehicle_title', this.control);
    if (!vehicleTitleControl) {
      return;
    }

    if (vehicleTitleControl.value === this.lastAutoTitle) {
      vehicleTitleControl.setValue(null);
      this.lastAutoTitle = null;
    }
  }
}
